import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, retry, retryWhen, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Customer } from '../../ect-feature/models/customer';
import { api, retryStrategy } from '../../shared/api-loaders';

@Injectable({
  providedIn: 'root'
})
export class CustomerSupportService {
  constructor(private http: HttpClient) { }

  storage = window[environment.storage];

  saveCustomer(customer: Customer): Observable<any> {
    return this.http.put(api.supportCustomers() + "/" + customer.accountId, {})
      .pipe(retryWhen(retryStrategy()),
        tap(x => {
          this.storage.setItem("selectedCustomer", JSON.stringify(customer));
        })
    );
  }
  deleteCustomer(): Observable<any> {

    return this.http.delete(api.supportCustomers() )
      .pipe(retryWhen(retryStrategy()),
        tap(x => {
          this.deleteStoredSelectedCustomer();
       })
      );
  }

  deleteStoredSelectedCustomer() {
    this.storage.removeItem("selectedCustomer");

  }

  getSelectedCustomer(): Customer {
    let c = this.storage.getItem("selectedCustomer");
    if (c)
      return JSON.parse(c);

    return null;
  }

  isCustomerSelected(): boolean {
    let c = this.getSelectedCustomer();
    if (!c)
      return false;

    if (!c.accountId)
      return false;

    return true;
      
  }

}
